(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["billboard-slider"] && !Shopify.designMode) return;
  try {
    
function billboardAddToCart(btn) {
  if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;

  const variantId = Number(btn.getAttribute('data-variant-id'));
  if (!variantId) return;

  const originalHtml = btn.innerHTML;
  btn.disabled = true;
  btn.setAttribute('aria-busy', 'true');
  btn.textContent = 'Adding...';

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  fetch(root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
  })
    .then((res) => {
      if (!res.ok) {
        return res.json().then((json) => {
          throw new Error(json.description || 'Add to cart failed');
        });
      }
      return res.json();
    })
    .then(() => {
      if (typeof CartManager !== 'undefined' && typeof CartManager.refreshCartUI === 'function') {
        CartManager.refreshCartUI({ variantId }).then(() => {
          if (typeof CartManager.openCart === 'function') CartManager.openCart();
        });
      }
      btn.textContent = 'Added!';
      window.setTimeout(() => {
        btn.innerHTML = originalHtml;
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }, 1500);
    })
    .catch((err) => {
      console.error('Billboard add to cart:', err);
      btn.innerHTML = originalHtml;
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    });
}

if (!customElements.get('billboard-slider-ui')) {
  customElements.define(
    'billboard-slider-ui',
    class BillboardSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-billboard-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-billboard-dot]'));
        this.status = this.querySelector('[data-billboard-status]');
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.isAnimating = false;
        this.timer = null;
        this.pointer = null;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this._onClick = this.onClick.bind(this);
        this._onKeyDown = this.onKeyDown.bind(this);
        this._onBlockSelect = this.onBlockSelect.bind(this);
        this._onPointerDown = this.onPointerDown.bind(this);
        this._onPointerUp = this.onPointerUp.bind(this);

        this.addEventListener('click', this._onClick);
        this.addEventListener('keydown', this._onKeyDown);
        this.addEventListener('pointerdown', this._onPointerDown);
        this.addEventListener('pointerup', this._onPointerUp);
        this.addEventListener('pointercancel', this._onPointerUp);
        document.addEventListener('shopify:block:select', this._onBlockSelect);

        this.setActive(this.index, true);
        this.classList.toggle('is-single', this.slides.length < 2);
        this.classList.add('is-ready');
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        this.removeEventListener('click', this._onClick);
        this.removeEventListener('keydown', this._onKeyDown);
        this.removeEventListener('pointerdown', this._onPointerDown);
        this.removeEventListener('pointerup', this._onPointerUp);
        this.removeEventListener('pointercancel', this._onPointerUp);
        document.removeEventListener('shopify:block:select', this._onBlockSelect);
      }

      onClick(event) {
        const feature = event.target.closest('[data-billboard-feature]');
        if (feature) {
          event.preventDefault();
          this.selectFeature(feature);
          return;
        }

        const atc = event.target.closest('[data-billboard-atc]');
        if (atc) {
          event.preventDefault();
          this.addToCart(atc);
          return;
        }

        if (event.target.closest('[data-billboard-next]')) {
          event.preventDefault();
          this.go(1);
        } else if (event.target.closest('[data-billboard-prev]')) {
          event.preventDefault();
          this.go(-1);
        } else {
          const dot = event.target.closest('[data-billboard-dot]');
          if (dot) {
            event.preventDefault();
            this.goTo(Number(dot.dataset.index), false);
          }
        }
      }

      selectFeature(button) {
        const slide = button.closest('[data-billboard-slide]');
        if (!slide) return;

        const mediaKey = button.getAttribute('data-billboard-media-key') || 'base';

        slide.querySelectorAll('[data-billboard-feature]').forEach((el) => {
          const on = el === button;
          el.classList.toggle('is-active', on);
          el.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        slide.querySelectorAll('[data-billboard-media-layer]').forEach((layer) => {
          layer.classList.toggle(
            'is-active',
            layer.getAttribute('data-billboard-media-layer') === mediaKey
          );
        });

        const fgKey = button.getAttribute('data-billboard-foreground-key') || 'base';
        const fgLayers = slide.querySelectorAll('[data-billboard-foreground-layer]');
        if (fgLayers.length) {
          const hasTarget = slide.querySelector(
            '[data-billboard-foreground-layer="' + fgKey + '"]'
          );
          const nextFg = hasTarget ? fgKey : 'base';
          fgLayers.forEach((layer) => {
            layer.classList.toggle(
              'is-active',
              layer.getAttribute('data-billboard-foreground-layer') === nextFg
            );
          });
        }
      }

      addToCart(btn) {
        billboardAddToCart(btn);
      }

      onPointerDown(event) {
        if (event.target.closest('button, a')) return;
        this.pointer = { x: event.clientX, y: event.clientY };
      }

      onPointerUp(event) {
        if (!this.pointer) return;
        const dx = event.clientX - this.pointer.x;
        const dy = event.clientY - this.pointer.y;
        this.pointer = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        this.go(dx < 0 ? 1 : -1);
      }

      onKeyDown(event) {
        const feature = event.target.closest('[data-billboard-feature]');
        if (feature && (event.key === 'ArrowRight' || event.key === 'ArrowLeft')) {
          event.preventDefault();
          const slide = feature.closest('[data-billboard-slide]');
          const features = Array.from(slide.querySelectorAll('[data-billboard-feature]'));
          const nextIndex = features.indexOf(feature) + (event.key === 'ArrowRight' ? 1 : -1);
          if (!features[nextIndex]) return;
          features[nextIndex].focus();
          this.selectFeature(features[nextIndex]);
          return;
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.go(1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(-1);
        }
      }

      onBlockSelect(event) {
        if (!this.contains(event.target)) return;
        const slide = event.target.matches('[data-billboard-slide]')
          ? event.target
          : event.target.querySelector('[data-billboard-slide]');
        if (!slide) return;
        const nextIndex = this.slides.indexOf(slide);
        if (nextIndex >= 0) this.goTo(nextIndex, true);
      }

      go(direction) {
        this.goTo(this.index + direction, false);
      }

      goTo(nextIndex, instant) {
        if (nextIndex === this.index) return;
        if (nextIndex < 0 || nextIndex >= this.slides.length) return;
        if (this.isAnimating && !instant) return;

        const fromSlide = this.slides[this.index];
        const toSlide = this.slides[nextIndex];
        const travel = nextIndex > this.index ? 1 : -1;

        window.clearTimeout(this.timer);
        this.classList.toggle('is-next', travel === 1);
        this.classList.toggle('is-prev', travel === -1);

        if (instant || this.reduceMotion) {
          this.setActive(nextIndex, true);
          return;
        }

        this.isAnimating = true;
        toSlide.classList.add('is-entering', 'is-active');
        toSlide.setAttribute('aria-hidden', 'false');
        fromSlide.classList.add('is-leaving');
        fromSlide.classList.remove('is-active');
        this.index = nextIndex;
        this.updateArrows(nextIndex);
        this.updatePager(nextIndex);

        this.timer = window.setTimeout(() => {
          fromSlide.classList.remove('is-leaving');
          toSlide.classList.remove('is-entering');
          this.setActive(nextIndex, true);
          this.isAnimating = false;
        }, 600);
      }

      setActive(nextIndex, silent) {
        this.slides.forEach((slide, index) => {
          const isActive = index === nextIndex;
          slide.classList.toggle('is-active', isActive);
          if (silent) {
            slide.classList.remove('is-leaving', 'is-entering');
          }
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
        this.index = nextIndex;
        this.updateArrows(nextIndex);
        this.updatePager(nextIndex);
        this.updateStatus();
      }

      updatePager(index) {
        const current = typeof index === 'number' ? index : this.index;
        this.dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === current;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }

      updateArrows(index) {
        const current = typeof index === 'number' ? index : this.index;
        const atStart = current <= 0;
        const atEnd = current >= this.slides.length - 1;

        this.querySelectorAll('[data-billboard-prev]').forEach((button) => {
          button.disabled = atStart;
        });
        this.querySelectorAll('[data-billboard-next]').forEach((button) => {
          button.disabled = atEnd;
        });
      }

      updateStatus() {
        if (!this.status || this.slides.length === 0) return;
        this.status.textContent = `Slide ${this.index + 1} of ${this.slides.length}`;
      }
    }
  );
}

if (!customElements.get('billboard-feature-card')) {
  customElements.define(
    'billboard-feature-card',
    class BillboardFeatureCard extends HTMLElement {
      connectedCallback() {
        this.panes = Array.from(this.querySelectorAll('[data-feature-pane]'));
        this.dots = Array.from(this.querySelectorAll('[data-feature-dot]'));
        this.index = Math.max(0, this.panes.findIndex((pane) => pane.classList.contains('is-active')));
        this.pointer = null;

        this._onClick = this.onClick.bind(this);
        this._onPointerDown = this.onPointerDown.bind(this);
        this._onPointerUp = this.onPointerUp.bind(this);

        this.addEventListener('click', this._onClick);
        this.addEventListener('pointerdown', this._onPointerDown);
        this.addEventListener('pointerup', this._onPointerUp);
        this.addEventListener('pointercancel', this._onPointerUp);

        if (this.index < 0) this.index = 0;
        this.select(this.index);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
        this.removeEventListener('pointerdown', this._onPointerDown);
        this.removeEventListener('pointerup', this._onPointerUp);
        this.removeEventListener('pointercancel', this._onPointerUp);
      }

      onClick(event) {
        const atc = event.target.closest('[data-billboard-atc]');
        if (atc) {
          event.preventDefault();
          billboardAddToCart(atc);
          return;
        }

        const dot = event.target.closest('[data-feature-dot]');
        if (dot) {
          event.preventDefault();
          this.select(Number(dot.dataset.index));
        }
      }

      onPointerDown(event) {
        if (event.target.closest('button, a')) return;
        this.pointer = { x: event.clientX, y: event.clientY };
      }

      onPointerUp(event) {
        if (!this.pointer) return;
        const dx = event.clientX - this.pointer.x;
        const dy = event.clientY - this.pointer.y;
        this.pointer = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        this.go(dx < 0 ? 1 : -1);
      }

      go(direction) {
        this.select(this.index + direction);
      }

      select(nextIndex) {
        if (nextIndex < 0 || nextIndex >= this.panes.length) return;

        this.panes.forEach((pane, index) => {
          pane.classList.toggle('is-active', index === nextIndex);
        });

        const pane = this.panes[nextIndex];
        const mediaKey = (pane && pane.getAttribute('data-billboard-media-key')) || 'base';
        const fgKey = (pane && pane.getAttribute('data-billboard-foreground-key')) || 'base';

        this.querySelectorAll('[data-billboard-media-layer]').forEach((layer) => {
          layer.classList.toggle(
            'is-active',
            layer.getAttribute('data-billboard-media-layer') === mediaKey
          );
        });

        const fgLayers = this.querySelectorAll('[data-billboard-foreground-layer]');
        if (fgLayers.length) {
          const hasTarget = this.querySelector(
            '[data-billboard-foreground-layer="' + fgKey + '"]'
          );
          const nextFg = hasTarget ? fgKey : 'base';
          fgLayers.forEach((layer) => {
            layer.classList.toggle(
              'is-active',
              layer.getAttribute('data-billboard-foreground-layer') === nextFg
            );
          });
        }

        this.dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === nextIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        this.index = nextIndex;
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('b-marquee')) {
    class ChirpMarquee extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound === 'true') return;
        this.dataset.bound = 'true';
        this.speed = Number(this.dataset.speed) || 45;
        this.root = this.closest('.b-marquee');
        this.control = this.root && this.root.querySelector('[data-marquee-control]');

        if (this.control) {
          this.onControl = () => {
            const paused = this.control.getAttribute('aria-pressed') === 'true';
            if (paused) {
              this.root.classList.remove('is-paused');
              this.root.classList.add('is-playing');
              this.control.setAttribute('aria-pressed', 'false');
              this.control.textContent = 'Pause';
            } else {
              this.root.classList.add('is-paused');
              this.root.classList.remove('is-playing');
              this.control.setAttribute('aria-pressed', 'true');
              this.control.textContent = 'Play';
            }
          };
          this.control.addEventListener('click', this.onControl);
        }

        this.onResize = () => {
          window.clearTimeout(this.resizeTimer);
          this.resizeTimer = window.setTimeout(() => this.fill(), 150);
        };
        this.observer = new ResizeObserver(this.onResize);
        this.observer.observe(this);

        this.onIntersect = (entries) => {
          this.toggleAttribute('data-offscreen', !entries[0].isIntersecting);
        };
        this.visibility = new IntersectionObserver(this.onIntersect);
        this.visibility.observe(this);

        this.fill();
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => this.fill());
        }
      }

      disconnectedCallback() {
        this.dataset.bound = 'false';
        if (this.control && this.onControl) {
          this.control.removeEventListener('click', this.onControl);
        }
        window.clearTimeout(this.resizeTimer);
        if (this.observer) this.observer.disconnect();
        if (this.visibility) this.visibility.disconnect();
      }

      fill() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        const viewport = this.clientWidth;
        if (!viewport) return;

        this.querySelectorAll('[data-marquee-row]').forEach((row) => {
          const track = row.querySelector('[data-marquee-track]');
          const group = row.querySelector('[data-marquee-group]');
          const clone = row.querySelector('[data-marquee-clone]');
          const sample = group && group.firstElementChild;
          if (!track || !group || !clone || !sample) return;

          const gap = parseFloat(getComputedStyle(group).columnGap) || 0;
          const unit = sample.offsetWidth + gap;
          if (!unit) return;

          const needed = Math.ceil(viewport / unit) + 2;
          while (group.childElementCount < needed) {
            group.appendChild(sample.cloneNode(true));
            clone.appendChild(sample.cloneNode(true));
          }

          const seconds = Math.max(group.offsetWidth / this.speed, 8);
          const next = seconds.toFixed(2) + 's';
          if (track.dataset.duration !== next) {
            track.dataset.duration = next;
            track.style.animationDuration = next;
          }
        });
      }
    }

    customElements.define('b-marquee', ChirpMarquee);
  }

  } catch(e) { console.error(e); }
})();
})();
